<app-tdo-image-picker (imageChange)="onImageChange($event)" [showLabel]="false" [path]="path" [dataSource]="dataSource" [selectedImage]="value" style="position: relative; top: 3px;" data-cy="user-icon-selector"></app-tdo-image-picker>
